import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useSEO from '../../hooks/useSEO';

const NotFound = () => {
  const { pathname } = useLocation();
  useSEO({
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist. Browse used taxis and commercial vehicles for sale across India on Buy Sell Taxi.',
    noindex: true,
    // Self canonical. Without a url, useSEO falls back to the HOMEPAGE — so
    // every unknown URL was a noindexed page claiming to be the homepage.
    url: `https://www.buyselltaxi.com${pathname}`,
  });

  return (
    <div style={{ maxWidth: '640px', margin: '0 auto', padding: '80px 20px', textAlign: 'center' }}>
      <div style={{ fontSize: '64px', marginBottom: '8px' }}>🚕</div>
      <h1 style={{ fontSize: '32px', marginBottom: '12px' }}>Page Not Found</h1>
      <p style={{ color: '#555', fontSize: '16px', marginBottom: '32px' }}>
        Sorry, we couldn't find that page. It may have been moved or the link is incorrect.
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link
          to="/"
          style={{
            background: 'var(--yellow, #f7d000)',
            color: '#111',
            padding: '12px 24px',
            borderRadius: '8px',
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          Go to Homepage
        </Link>
        <Link
          to="/vehicles"
          style={{
            border: '1px solid #ddd',
            color: '#111',
            padding: '12px 24px',
            borderRadius: '8px',
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          Browse Vehicles
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
